module.exports = __webpack_public_path__ + "cornerSprite-11d0d473ccb30bdb1e610e0f9b9a76e3.png";